<template lang="pug">
    v-dialog(
        v-model='dialog'
        fullscreen
        scrollable
        transition='dialog-bottom-transition'
    )
        template(v-slot:activator='{ on, attrs }')
            v-btn.volie-color-blue(
                v-bind='attrs'
                v-on='on'
                dark
                ripple
                rounded
                outlined
                style="border-color: var(--volie-blue);"
            )
                template(v-if='windowWidth >= 1680')
                    | {{ originDirection | titleize }} Calls Today: {{ (originCallsToday || 0) | number }}
                template(v-else)
                    template(v-if="originDirection === 'inbound'")
                        v-icon mdi-phone-incoming
                        span
                            | : {{ (originCallsToday || 0) | number }}
                    template(v-else-if="originDirection === 'outbound'")
                        v-icon mdi-phone-outgoing
                        span
                            | : {{ (originCallsToday || 0) | number }}

        v-card
            v-toolbar
                v-btn(icon @click='closeDialog();')
                    v-icon mdi-close
                v-toolbar-title Today's Call Log
                v-spacer
                div(style="width: 300px;")
                    v-text-field(v-if="!validCustomer" dense @click='searchDialog = true' @click:append='() => searchDialog = true' @click:prepend-inner='() => searchDialog = true' prepend-inner-icon='mdi-magnify' label='Search' single-line hide-details readonly outlined filled )
                v-dialog(v-model='searchDialog' max-width='600px')
                    v-card
                        v-card-title
                            span.text-h5 Search Calls
                        v-card-text
                            v-container
                                v-row
                                    v-col(cols='12')
                                        v-autocomplete(v-model='searchObj.organizationIds' multiple :items='organizationUsers' label='Organization' item-text="organization_name" item-value="organization_id" clearable)
                                            template(v-slot:selection='{ item, index }')
                                                v-chip(v-if='index === 0')
                                                    span {{ item.organization_name }}
                                                span.grey--text.caption(v-if='index === 1')
                                                    | (+{{ searchObj.organizationIds.length - 1 }} others)

                                v-row
                                    v-col(cols="12")
                                        v-text-field(label='Campaign' type='text' v-model="searchObj.campaignName")

                                v-row
                                    v-col(cols='12')
                                        v-select(
                                            v-model='searchObj.direction'
                                            :items='directions'
                                            label='Direction'
                                            item-text="key"
                                            item-value="value"
                                        )
                                v-row
                                    v-col(cols="12")
                                        v-text-field(label='Disposition' type='text' v-model="searchObj.dispositionDescription")
                                
                                v-row
                                    v-col(cols='12')
                                        v-menu(
                                            v-model='startDatePickerMenu'
                                            :close-on-content-click='false'
                                            transition='scale-transition'
                                            offset-y
                                            max-width="330"
                                            min-width="auto"
                                        )
                                            template(v-slot:activator='{ on, attrs }')
                                                v-text-field(
                                                    v-model='formatStartTimeDate'
                                                    label='Date'
                                                    readonly
                                                    v-bind='attrs'
                                                    v-on='on'
                                                )
                                            v-date-picker(
                                                v-model='searchObj.startDate'
                                                no-title
                                                @change="handleChangeStartDate();"
                                                @input='startDatePickerMenu = false'
                                            )

                        v-card-actions
                            v-spacer
                            v-btn.ma-2(color="var(--volie-blue)" outlined ripple left @click='searchDialog = false;')
                                v-icon mdi-window-close
                                | Close
                            v-btn.ma-2(color="var(--volie-blue)" outlined ripple left @click='searchDialog = false; reinitSearch();')
                                v-icon mdi-refresh
                                | Reset
                            v-btn.ma-2(color="var(--volie-blue)" style="color: white;" ripple left @click='searchDialog = false; searchCalls();')
                                v-icon mdi-magnify
                                | Search

            v-card-text.pa-md-4.brown.lighten-5(style="height: 100vh;")
                .text-center(v-if="isLoading")
                    v-progress-circular(
                        :size='100'
                        :width='10'
                        color='var(--volie-blue)'
                        indeterminate
                        style="margin-top: 100px;"
                    )

                BaseCustomerProfile(
                    v-else-if="validCustomer"
                    :customer-id="customerID"
                    :exit="exitCustomerProfile"
                    includeComponentInHeight
                )

                v-card(v-else)
                    v-card-text
                        v-simple-table.ma-md-4.table-x-scroll(v-if="validCalls")
                            template(v-slot:default)
                                thead
                                    tr
                                        th
                                        th Time
                                        th Direction
                                        th Organization
                                        th Campaign
                                        th Customer
                                        th Disposition
                                        th To Number
                                        th From Number
                                        th Duration
                                        th
                                tbody
                                    tr(
                                        v-for='(call, idx) in calls'
                                        :key='call.call_id'
                                    )
                                        td.no-wrap.xs-xs-width {{ idx + 1 | number }}
                                        td.no-wrap.sm-width
                                            template(v-if="!!call.start_time_time") {{ call.start_time_time }}
                                            template(v-else) PROCESSING
                                        td.no-wrap.sm-width
                                            template(v-if="call.direction === '1'") Inbound
                                            template(v-if="call.direction === '2'") Outbound
                                        td.no-wrap.sm-width
                                            v-tooltip(top)
                                                template(v-slot:activator='{ on, attrs }')
                                                    span(v-bind="attrs" v-on="on" role="text")
                                                        | {{ call.organization_name | str_limit(35) }}
                                                span
                                                    | {{ call.organization_name }}
                                        td.no-wrap.sm-width
                                            v-tooltip(top)
                                                template(v-slot:activator='{ on, attrs }')
                                                    span(v-bind="attrs" v-on="on" role="text")
                                                        | {{ call.campaign_name | str_limit(35) }}
                                                span
                                                    | {{ call.campaign_name }}
                                        td.no-wrap.sm-width
                                            v-tooltip(bottom v-if="call.customer_id > 0")
                                                template(v-slot:activator='{ on, attrs }')
                                                    v-btn.mr-2(
                                                        outlined
                                                        fab
                                                        x-small
                                                        color="success"
                                                        @click="viewProfile(call.customer_id);"
                                                        v-bind='attrs'
                                                        v-on='on'
                                                    )
                                                        v-icon
                                                            | mdi-eye
                                                span View profile
                                            
                                            template(v-if="call.customer_full_name")
                                                v-tooltip(top)
                                                    template(v-slot:activator='{ on, attrs }')
                                                        span(v-bind="attrs" v-on="on" role="text")
                                                            | {{ call.customer_full_name | str_limit(35) }}
                                                    span
                                                        | {{ call.customer_full_name }}
                                            template(v-else) ---

                                        td.no-wrap.sm-width
                                            template(v-if="!!call.disposition_description")
                                                v-tooltip(top)
                                                    template(v-slot:activator='{ on, attrs }')
                                                        span(v-bind="attrs" v-on="on" role="text")
                                                            | {{ call.disposition_description | str_limit(50) }}
                                                    span
                                                        | {{ call.disposition_description }}
                                            template(v-else) ---
                                        td.no-wrap.sm-width {{ call.friendly_to_number | tel }}
                                        td.no-wrap.sm-width {{ call.friendly_from_number | tel }}
                                        td.no-wrap.sm-width {{ (call.agent_talk_duration || 0) | secondsToFullWords }}
                                        td.no-wrap.sm-width(v-if="call.customer_full_name !== ''")
                                            v-tooltip(top)
                                                template(v-slot:activator='{ on, attrs }')
                                                    v-btn(
                                                        :disabled="callsDisabled"
                                                        icon
                                                        small 
                                                        color="primary" 
                                                        dark 
                                                        @click='handleInitiateCall(call)'         
                                                        v-bind="attrs"
                                                        v-on="on"
                                                    )
                                                        v-icon mdi-phone-outgoing
                                                span Initiate Call
                                        td.no-wrap.sm-width(v-else)
                                            span

                                    tr(v-if="showMore")
                                        td.text-center(colspan='10')
                                            v-btn.volie-color-blue(link text ripple small @click="getCalls();")
                                                | Show more

                        v-alert.mx-lg-auto.mt-md-4.mb-md-4(type="warning" v-else)
                            | Unable to find any calls

</template>

<script lang="ts">
    import Vue from 'vue';
    import VolieState  from "@/store";

    // Components
    import BaseCustomerProfile from '@/components/customers/base_customer_profile.vue';

    // Data
    import { GetCalls, GetOrganizationUsers } from "@/data";

    export default Vue.extend({
        data() {
            return {
                calls: [],
                customerID: null,
                dialog: false,
                directions: [
                    { key: "Both", value: "" },
                    { key: "Inbound", value: "inbound" },
                    { key: "Outbound", value: "outbound" },
                ],
                formatStartTimeDate: null,
                isLoading: false,
                lastConferenceID: null,
                limit: 100,
                organizationUsers: [],
                searchDialog: false,
                searchObj: {},
                startDatePickerMenu: false,
                windowWidth: 0,
            }
        },
        methods: {
            closeDialog() {
                this.searchDialog = false;
                this.dialog = false;
            },
            exitCustomerProfile() {
                this.customerID = null;
            },
            formatDate (date) {
                if (!date) {
                    return null;
                }

                const [year, month, day] = date.split('-');
                return `${month}/${day}/${year}`;
            },
            getCalls() {

                // Init
                const options = {
                    campaign_name: this.searchObj?.campaignName,
                    disposition_description: this.searchObj?.dispositionDescription,
                    end_date: this.searchObj.startDate,
                    friendly_direction: this.searchObj?.direction,
                    last_conference_id: (this.lastConferenceID || 0),
                    limit: this.limit,
                    organization_ids: this.searchObj?.organizationIds,
                    sort_by_column_name: 'created_at',
                    sort_by_direction: 'desc',
                    start_date: this.searchObj.startDate,
                    user_id: (this.currentUser?.user_id || 0),
                }

                GetCalls(options).then((response) => {
                    if (response?.Data?.calls?.length > 0) {
                        if (!!this.calls && this.calls.length > 0) {
                            this.calls = this.calls.concat(response.Data.calls);
                        } else {
                            this.calls = response.Data.calls;
                        }

                        // Get last record and set ID
                        this.lastConferenceID = this.calls[this.calls.length - 1]?.conference_id;
                    }

                    this.isLoading = false;
                });
            },
            getOrganizationUsers() {
                GetOrganizationUsers().then((response) => {
                    if (!!response.Data && !!response.Data.organization_users && response.Data.organization_users.length > 0) {
                        this.organizationUsers = response.Data.organization_users;
                    }
                });
            },
            handleChangeStartDate() {
                // Validate and ensure the date is in YYYY-MM-DD format
                if (this.searchObj?.startDate) {
                    // Force local time interpretation by adding time component
                    const dateString = `${this.searchObj.startDate}T00:00:00`;
                    const date = new Date(dateString);
                    if (isNaN(date.getTime())) {
                        // Invalid date, reset to today
                        this.searchObj.startDate = this.initServerDate();
                    } else {
                        // Ensure proper YYYY-MM-DD format
                        const year = date.getFullYear();
                        const month = String(date.getMonth() + 1).padStart(2, '0');
                        const day = String(date.getDate()).padStart(2, '0');
                        this.searchObj.startDate = `${year}-${month}-${day}`;
                    }
                }
                this.formatStartTimeDate = this.formatDate(this.searchObj?.startDate);
            },
            handleInitiateCall(call) {
                const payload = {
                    appointment_id: null,
                    conference_id: call.conference_id,
                }
                VolieState.setTopNavManualCall(payload);
                this.closeDialog();
            },
            handleWindowResize() {
                if (window?.innerWidth > 0) {
                    this.windowWidth = window.innerWidth;
                    return;
                }

                this.windowWidth = 0;
            },
            initServerDate() {
                const d = new Date();
                const year = d.getFullYear();
                const month = String(d.getMonth() + 1).padStart(2, '0');
                const day = String(d.getDate()).padStart(2, '0');
                return `${year}-${month}-${day}`;
            },
            reinitSearch() {
                this.resetSearchObj();
                this.searchCalls();
            },
            resetSearchObj() {
                this.searchObj = {
                    campaignName: null,
                    direction: this.originDirection,
                    dispositionDescription: null,
                    organizationIds: [],
                    startDate: this.initServerDate(),
                }

                this.formatStartTimeDate = this.formatDate(this.searchObj?.startDate);
            },
            searchCalls() {
                this.isLoading = true;
                this.calls = [];
                this.lastConferenceID = null;
                this.getCalls();
            },
            viewProfile(customerID) {
                this.customerID = customerID;
            },
        },
        computed: {
            callsDisabled() {
                return this.$route.path !== '/communication_center';
            },
            currentUser() {
                return VolieState.currentUser();
            },
            showMore() {
                return (this.calls?.length > 0 && this.calls.length % this.limit === 0);
            },
            validCalls() {
                return this.calls?.length > 0;
            },
            validCustomer() {
                return this.customerID > 0;
            },
        },
        components: {
            BaseCustomerProfile,
        },
        props: {
            originCallsToday: Number,
            originDirection: String,
        },
        watch: {
            dialog() {
                // Load only as dialog is opened
                if (this.dialog) {
                    this.getOrganizationUsers();
                    this.reinitSearch();
                }
            },
        },
        created() {
            this.handleWindowResize();
            window.addEventListener('resize', this.handleWindowResize);
        },
        destroyed() {
            window.removeEventListener('resize', this.handleWindowResize);
        },
    });
</script>

<style lang="scss" scoped>
</style>
